import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('shop'),
  mainShopId: null
}

const getters = {
  ...restful.getters('shop'),
  // .filter(data => data.id !== state.mainShopId)
  otherShops: (state) => state.shops.filter(data => data.is_cloned_main_shop)
}

const actions = {
  ...restful.actions('shops'),
  // async activate ({ commit }, params) {
  //   Spin.show()
  //   const response = await axios.post(`shops/${params.id}/activate`, params)
  //   commit('updateRecordInRecords', response.data)
  //   Spin.hide()
  //   Message.success('激活成功!')
  // },
  // async shop_reduce ({ commit }, id) {
  //   Spin.show()
  //   const response = await axios.post(`shops/${id}/shop_reduce`)
  //   commit('updateRecordInRecords', response.data)
  //   Spin.hide()
  //   Message.success('降级标准版成功!')
  // },
  async mark_cloned_main   ({ commit }, id) {
    Spin.show()
    await axios.post(`shops/${id}/mark_cloned_main`)
    Spin.hide()
    Message.success('操作成功!')
  },
  async bind_parent_shop ({ commit, state }, id) {
    Spin.show()
    await axios.post(`shops/${state.mainShopId}/bind_parent_shop`, {
      parent_shop_id: id
    })
    Spin.hide()
    Message.success('绑定成功!')
  },
  async unbind_parent_shop ({ commit }, { id, parent_shop_id }) {
    Spin.show()
    await axios.post(`shops/${id}/unbind_parent_shop`, {
      parent_shop_id
    })
    Spin.hide()
    Message.success('解绑成功!')
  }
}

const mutations = {
  ...restful.mutations('shop'),
  mainShopId (state, val) {
    state.mainShopId = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
